import { fileMasiveConstants } from '../constants';
import { fileMasiveRequests } from '../../services';
import { handleErrorMessage } from '../../utils';

export const fileMasiveActions = {}

fileMasiveActions.GetSignatureRequestsByUsuario = (data) => {
  return dispatch => {
    dispatch(request())
    fileMasiveRequests.GetSignatureRequestsByUsuario(data)
      .then(
        dataSearch => dispatch(success(dataSearch)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: fileMasiveConstants.FILE_SEARCH_MASIVE_REQUEST }
  }

  function success(dataSearch) {
    return { type: fileMasiveConstants.FILE_SEARCH_MASIVE_SUCCESS, dataSearch }
  }

  function failure(error) {
    return { type: fileMasiveConstants.FILE_SEARCH_MASIVE_FAILURE, error }
  }
}

fileMasiveActions.UploadBatchSign = (data, isReset = false) => {
  console.log('RESETFIRMA',data, isReset )
  return dispatch => {
    if (isReset) {
      dispatch(reset())
    } else {
      dispatch(request())
      fileMasiveRequests.UploadBatchSign(data)
        .then(
          dataSearch => { dispatch(success(dataSearch)) },
          error => dispatch(failure(handleErrorMessage(error)))
        )
    }
  }

  function request() {
    return { type: fileMasiveConstants.UPLOAD_SIGN_MASIVE_REQUEST }
  }

  function success(dataSearch) {
    return { type: fileMasiveConstants.UPLOAD_SIGN_MASIVE_SUCCESS, dataSearch }
  }

  function failure(error) {
    return { type: fileMasiveConstants.UPLOAD_SIGN_MASIVE_FAILURE, error }
  }

  function reset() {
    console.log('UploadBatchSign RESET')
    return { type: fileMasiveConstants.UPLOAD_SIGN_MASIVE_RESET }
  }
}


/* ---------------------------------------------------------------------------- */


fileMasiveActions.GetByUsuarioRolDetalleGrupo = (data) => {
  return dispatch => {
    dispatch(request())
    fileMasiveRequests.GetByUsuarioRolDetalleGrupo(data)
      .then(
        dataSearch => dispatch(success(dataSearch)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: fileMasiveConstants.FILE_SEARCH_MASIVE_DEATILS_GROUP_REQUEST }
  }

  function success(dataSearch) {
    return { type: fileMasiveConstants.FILE_SEARCH_MASIVE_DEATILS_GROUP_SUCCESS, dataSearch }
  }

  function failure(error) {
    return { type: fileMasiveConstants.FILE_SEARCH_MASIVE_DEATILS_GROUP_FAILURE, error }
  }
}


fileMasiveActions.UsersSignersMasives = (data) => {
  return {
    type: fileMasiveConstants.GET_USERS_SIGNS_MASIVE,
    payload: data,
  };
};

